export default function PHP_print_r() {
  return (
    <div>
      <h1>PHP_print_r</h1>
    </div>
  );
}
